import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu } from "antd";
import {
  HomeOutlined,
  QuestionCircleOutlined,
  RocketOutlined,
  StarOutlined
} from "@ant-design/icons";

export const AppHeader = () => {
  const [current, setCurrent] = useState("");

  const handleClick = (e: any) => {
    setCurrent(e.key);
  };

  return (
    <Menu onClick={handleClick} selectedKeys={[current]} mode="horizontal">
      <Menu.Item key="home" icon={<HomeOutlined />}>
        <NavLink to="/">Home</NavLink>
      </Menu.Item>
      <Menu.Item key="about" icon={<QuestionCircleOutlined />}>
        <NavLink to="/about">About</NavLink>
      </Menu.Item>
      <Menu.Item key="scs" icon={<RocketOutlined />}>
        <NavLink to="/scs">Ships/Colonies</NavLink>
      </Menu.Item>
      <Menu.Item key="systems" icon={<StarOutlined />}>
        <NavLink to="/systemss">Systems</NavLink>
      </Menu.Item>
    </Menu>
  );
};
